export default __webpack_public_path__ + "static/image-1-857f1c12d2a246849e4d62b9ff3519a0.jpg";